"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWithinDateTimeRange = exports.getLocalJSDate = exports.getSelectedDateText = exports.getSelectedPayDayText = exports.getSelectedPayPeriodText = exports.addMinutes = exports.getHoursDifference = exports.getMinutesDifference = exports.getDisplayMonthDay = exports.getLocalizedDurationWithUnit = exports.getLocalizedDuration = exports.getDisplayWeekday = exports.getTimeStringFromPopupDatePicker = exports.getPayCodesRequestDateTimeString = exports.getUpdatePayDataRequestDateTimeString = exports.getSelfClassificationDateTimeString = exports.trimISOStringSeconds = exports.trimISOStringMilliseconds = exports.createISOWithoutMillisecond = exports.createDTDayInDefaultTZ = exports.getNextDateString = exports.getDateString = exports.areDatesEqual = exports.parsePunchTime = exports.convertTimeStringToMilitaryTimeString = exports.convertTimeStringToJsTimeString = exports.getTimeString = exports.setTimeZone = exports.setTimeZoneAndLocale = exports.GET_PAY_CODES_DATE_TIME_FORMAT = exports.USE_UPDATE_PAY_DATA_DATE_TIME_FORMAT = exports.POPUP_DATE_PICKER_TEXT_INPUT_FORMAT = exports.POPUP_DATE_PICKER_TIME_SELECTOR_FORMAT = void 0;
const luxon_1 = require("luxon");
const types_1 = require("../../types");
exports.POPUP_DATE_PICKER_TIME_SELECTOR_FORMAT = 'y-LL-dd HH:mm';
exports.POPUP_DATE_PICKER_TEXT_INPUT_FORMAT = 'LLddyyyyHHmm';
exports.USE_UPDATE_PAY_DATA_DATE_TIME_FORMAT = "y-LL-dd'T'HH:mm:ssZZ";
exports.GET_PAY_CODES_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss'Z'";
const setTimeZoneAndLocale = (timeZone, locale = 'en-US') => {
    luxon_1.Settings.defaultLocale = locale;
    if (timeZone && luxon_1.IANAZone.isValidZone(timeZone)) {
        luxon_1.Settings.defaultZone = timeZone;
    }
};
exports.setTimeZoneAndLocale = setTimeZoneAndLocale;
const setTimeZone = (timeZone) => {
    if (timeZone && luxon_1.IANAZone.isValidZone(timeZone)) {
        luxon_1.Settings.defaultZone = timeZone;
    }
};
exports.setTimeZone = setTimeZone;
const getTimeString = (date, militaryTime) => {
    return militaryTime
        ? date.toLocaleString(luxon_1.DateTime.TIME_24_SIMPLE)
        : date.toLocaleString(luxon_1.DateTime.TIME_SIMPLE);
};
exports.getTimeString = getTimeString;
const convertTimeStringToJsTimeString = (time) => {
    return `${(0, exports.convertTimeStringToMilitaryTimeString)(time)}:00`;
};
exports.convertTimeStringToJsTimeString = convertTimeStringToJsTimeString;
const convertTimeStringToMilitaryTimeString = (time) => {
    const [timeString, amPm] = time.split(' ');
    const [hour, minutes] = timeString.split(':');
    if (amPm === 'am') {
        if (Number(hour) < 12) {
            return timeString;
        }
        return `00:${minutes}`;
    }
    if (Number(hour) < 12) {
        return `${Number(hour) + 12}:${minutes}`;
    }
    return `12:${minutes}`;
};
exports.convertTimeStringToMilitaryTimeString = convertTimeStringToMilitaryTimeString;
const parsePunchTime = (punchTime, selectedDate, useMilitaryTime) => {
    const time = punchTime.split(' ')[0].split(':');
    let hours = parseInt(time[0]);
    const minutes = parseInt(time[1]);
    if (!useMilitaryTime) {
        if (hours === 12) {
            hours = 0;
        }
        const sign = punchTime.split(' ')[1];
        if (sign === 'pm' || sign === 'P') {
            hours += 12;
        }
    }
    return selectedDate.set({
        hour: hours,
        minute: minutes
    });
};
exports.parsePunchTime = parsePunchTime;
const areDatesEqual = (date1, date2) => {
    return (date1.day === date2.day &&
        date1.month === date2.month &&
        date1.year === date2.year);
};
exports.areDatesEqual = areDatesEqual;
function getDateString(day) {
    if (typeof day === 'string') {
        day = luxon_1.DateTime.fromISO(day);
    }
    if (day instanceof luxon_1.DateTime) {
        return luxon_1.DateTime.fromObject({
            year: day.year,
            month: day.month,
            day: day.day
        }).toISODate();
    }
    return luxon_1.DateTime.fromObject({
        year: day.getFullYear(),
        month: day.getMonth() + 1,
        day: day.getDate()
    }).toISODate();
}
exports.getDateString = getDateString;
function getNextDateString(day) {
    if (typeof day === 'string') {
        day = luxon_1.DateTime.fromISO(day);
    }
    if (day instanceof luxon_1.DateTime) {
        day = luxon_1.DateTime.fromObject({
            year: day.year,
            month: day.month,
            day: day.day
        });
    }
    if (day instanceof Date) {
        day = luxon_1.DateTime.fromObject({
            year: day.getFullYear(),
            month: day.getMonth() + 1,
            day: day.getDate()
        });
    }
    return day.plus({ days: 1 }).toISODate();
}
exports.getNextDateString = getNextDateString;
function createDTDayInDefaultTZ(day) {
    if (!luxon_1.DateTime.fromJSDate(day).isValid) {
        return luxon_1.DateTime.fromJSDate(day);
    }
    return luxon_1.DateTime.fromFormat(getDateString(day), 'y-MM-dd');
}
exports.createDTDayInDefaultTZ = createDTDayInDefaultTZ;
function createISOWithoutMillisecond(dateTime) {
    return dateTime.set({ millisecond: 0 }).toISO({ suppressMilliseconds: true });
}
exports.createISOWithoutMillisecond = createISOWithoutMillisecond;
function trimISOStringMilliseconds(dateTime) {
    return dateTime
        .toUTC()
        .set({ millisecond: 0 })
        .toISO({ suppressMilliseconds: true });
}
exports.trimISOStringMilliseconds = trimISOStringMilliseconds;
function trimISOStringSeconds(dateTime) {
    return dateTime.toUTC().toISO({ suppressSeconds: true });
}
exports.trimISOStringSeconds = trimISOStringSeconds;
const getSelfClassificationDateTimeString = (dateTimeStr, timeZone) => {
    const dateTime = luxon_1.DateTime.fromISO(dateTimeStr);
    return dateTime
        .setZone(timeZone)
        .toFormat(exports.POPUP_DATE_PICKER_TIME_SELECTOR_FORMAT);
};
exports.getSelfClassificationDateTimeString = getSelfClassificationDateTimeString;
const getUpdatePayDataRequestDateTimeString = (dateTimeStr, timeZone) => {
    const dateTime = luxon_1.DateTime.fromFormat(dateTimeStr, exports.POPUP_DATE_PICKER_TIME_SELECTOR_FORMAT, { zone: timeZone });
    return dateTime.toFormat(exports.USE_UPDATE_PAY_DATA_DATE_TIME_FORMAT);
};
exports.getUpdatePayDataRequestDateTimeString = getUpdatePayDataRequestDateTimeString;
const getPayCodesRequestDateTimeString = (dateTimeStr) => {
    const dateTime = luxon_1.DateTime.fromISO(dateTimeStr).toUTC();
    return dateTime.toFormat(exports.GET_PAY_CODES_DATE_TIME_FORMAT);
};
exports.getPayCodesRequestDateTimeString = getPayCodesRequestDateTimeString;
const getTimeStringFromPopupDatePicker = (datePickerInputStr) => {
    const dtFromDatePickerTimeSelector = luxon_1.DateTime.fromFormat(datePickerInputStr, exports.POPUP_DATE_PICKER_TIME_SELECTOR_FORMAT);
    const dtFromDatePickerTextInput = luxon_1.DateTime.fromFormat(datePickerInputStr, exports.POPUP_DATE_PICKER_TEXT_INPUT_FORMAT);
    return dtFromDatePickerTimeSelector.isValid
        ? datePickerInputStr
        : dtFromDatePickerTextInput.toFormat(exports.POPUP_DATE_PICKER_TIME_SELECTOR_FORMAT);
};
exports.getTimeStringFromPopupDatePicker = getTimeStringFromPopupDatePicker;
const getDisplayWeekday = (date) => {
    return luxon_1.DateTime.fromISO(date).toLocaleString({ weekday: 'short' });
};
exports.getDisplayWeekday = getDisplayWeekday;
const getLocalizedDuration = (durationObject, t) => {
    const duration = luxon_1.Duration.fromObject(durationObject)
        .shiftTo('hours', 'minutes')
        .toObject();
    const hoursText = !!duration.hours
        ? `${duration.hours}${t('time_and_attendance_hour_abbr')}`
        : '';
    const minutesText = !!duration.minutes
        ? ` ${Math.round(duration.minutes)}${t('time_and_attendance_minute_abbr')}`
        : '';
    return `${hoursText}${minutesText}`;
};
exports.getLocalizedDuration = getLocalizedDuration;
const getLocalizedDurationWithUnit = (amount, unit, t) => {
    if (unit === types_1.PayPeriodBreakdownUnit.DAYS) {
        return `${amount}${t('time_and_attendance_day_abbr')}`;
    }
    else {
        let durationUnit;
        switch (unit) {
            case types_1.PayPeriodBreakdownUnit.SECONDS:
                durationUnit = 'second';
                break;
            case types_1.PayPeriodBreakdownUnit.MINUTES:
                durationUnit = 'minute';
                break;
            default:
                durationUnit = 'minute';
        }
        const durationObject = {
            [durationUnit]: amount
        };
        const duration = luxon_1.Duration.fromObject(durationObject)
            .shiftTo('hours', 'minutes')
            .toObject();
        const hoursText = !!duration.hours
            ? `${duration.hours}${t('time_and_attendance_hour_abbr')}`
            : '';
        const minutesText = !!duration.minutes
            ? ` ${Math.round(duration.minutes)}${t('time_and_attendance_minute_abbr')}`
            : '';
        return `${hoursText}${minutesText}`.trim();
    }
};
exports.getLocalizedDurationWithUnit = getLocalizedDurationWithUnit;
const getDisplayMonthDay = (date) => {
    return luxon_1.DateTime.fromISO(date).toLocaleString({
        month: 'short',
        day: 'numeric'
    });
};
exports.getDisplayMonthDay = getDisplayMonthDay;
const getMinutesDifference = (start, end) => {
    const startDT = luxon_1.DateTime.fromISO(start);
    const endDT = luxon_1.DateTime.fromISO(end);
    return endDT.diff(startDT, 'minutes').minutes;
};
exports.getMinutesDifference = getMinutesDifference;
const getHoursDifference = (start, end) => {
    const startDt = luxon_1.DateTime.fromISO(start);
    const endDt = luxon_1.DateTime.fromISO(end);
    return endDt.diff(startDt, 'hours').hours;
};
exports.getHoursDifference = getHoursDifference;
const addMinutes = (dateTime, minutes) => {
    return luxon_1.DateTime.fromISO(dateTime).plus({ minutes }).toISO();
};
exports.addMinutes = addMinutes;
const getSelectedPayPeriodText = (selectedPayPeriod) => {
    const startDateTime = luxon_1.DateTime.fromSQL(selectedPayPeriod.startDate);
    const endDateTime = luxon_1.DateTime.fromSQL(selectedPayPeriod.endDate);
    return `${startDateTime.toLocaleString({
        month: 'short',
        day: '2-digit'
    })} - ${endDateTime.toLocaleString({
        month: 'short',
        day: '2-digit'
    })}`;
};
exports.getSelectedPayPeriodText = getSelectedPayPeriodText;
const getSelectedPayDayText = (selectedPayPeriod) => {
    const payDateTime = luxon_1.DateTime.fromSQL(selectedPayPeriod.payDate);
    return `${payDateTime.toLocaleString({
        month: 'short',
        day: '2-digit'
    })}`;
};
exports.getSelectedPayDayText = getSelectedPayDayText;
const getSelectedDateText = (selectedDay) => {
    const selectedDateTime = luxon_1.DateTime.fromSQL(selectedDay);
    return `${selectedDateTime.toLocaleString({
        month: 'short',
        day: '2-digit',
        year: 'numeric'
    })}`;
};
exports.getSelectedDateText = getSelectedDateText;
const getLocalJSDate = (dateTime) => {
    return new Date(dateTime.get('year'), dateTime.get('month') - 1, dateTime.get('day'));
};
exports.getLocalJSDate = getLocalJSDate;
const isWithinDateTimeRange = (checkDateTime, startDateTime, endDateTime) => {
    const checkDateTimeToUse = typeof checkDateTime === 'string'
        ? luxon_1.DateTime.fromISO(checkDateTime)
        : checkDateTime;
    const startDateTimeToUse = typeof startDateTime === 'string'
        ? luxon_1.DateTime.fromISO(startDateTime)
        : startDateTime;
    const endDateTimeToUse = typeof endDateTime === 'string'
        ? luxon_1.DateTime.fromISO(endDateTime)
        : endDateTime;
    return (checkDateTimeToUse >= startDateTimeToUse &&
        checkDateTimeToUse <= endDateTimeToUse);
};
exports.isWithinDateTimeRange = isWithinDateTimeRange;
